import React from 'react';
import StationTrainingGuide from '../../../components/StationTrainingGuide';
import RacePlanGenerator from '../../../components/RacePlanGenerator';

export const StationsSection = () => (
  <section id="stations" className="bg-[#050505] section-spacing" data-testid="hyrox-stations-section">
    <div className="container-ninja">
      <div className="max-w-4xl mx-auto">
        <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3">Master Every Station</p>
        <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">Station Training Guides</h2>
        <p className="text-zinc-400 mb-8 max-w-2xl">
          Each station demands specific technique. Click any station to reveal form videos, race strategies, common mistakes to avoid, and the exact drills to train each movement.
        </p>
        <StationTrainingGuide />
      </div>
    </div>
  </section>
);

export const RacePlanSection = () => (
  <section id="raceplan" className="bg-[#0a0a0a] section-spacing" data-testid="hyrox-raceplan-section">
    <div className="container-ninja">
      <div className="max-w-4xl mx-auto">
        <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3">AI-Powered Training</p>
        <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">Personal Race Plan</h2>
        <p className="text-zinc-400 mb-8 max-w-2xl">
          Generate a personalized 8-week training program based on your experience level, fitness goals, and current benchmarks. Powered by AI.
        </p>
        <RacePlanGenerator />
      </div>
    </div>
  </section>
);
